<template>
    <div>
        <el-dialog :visible.sync="visible" class="doedit" width="960px" :close-on-click-modal="false"
                   :before-close="beforeClose">
            <div slot="title">
                <z-title title="操作日志"></z-title>
            </div>
            <div class="plr-20 content lh-30">
                <el-table
                        v-loading="loading"
                        element-loading-text="列表刷新中"
                        element-loading-spinner="el-icon-loading"
                        header-cell-class-name="headerrow"
                        cell-class-name="cellclass"
                        :data="dataList"
                        style="width: 100%">
                    <el-table-column
                            fixed
                            align="center"
                            prop="createTime"
                            label="操作时间"
                            width="160">
                    </el-table-column>
                    <el-table-column
                            prop="title"
                            label="标题"
                            width="120"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            prop="changeNote"
                            label="操作内容"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            fixed="right"
                            prop="createUserName"
                            label="操作人"
                            width="120"
                            align="center">
                    </el-table-column>
                </el-table>
            </div>
            <pagination :current-page="currentPage" :page-size="pageSize" :total="total"   @sizeChange="handleSizeChange"
                        @currentChange="handleCurrentChange"></pagination>
        </el-dialog>

    </div>
</template>

<script>
    import ZTitle from "../../../components/ZTitle";
    import Pagination from "../../../components/pagination/pagination";

    export default {
        components: {
            Pagination,
            ZTitle},
        name: "view-log",
        props: {
            visible: Boolean,
            id: String,
            type:String
        },
        data() {
            return {
                dataList: [],
                loading:false,
                currentPage: 1,
                pageSize: 20,
                total: 0,
            }
        },
        watch: {
            visible(newval, oldval) {
                if(newval)
                    this.getDataList();
            }
        },
        methods: {
            getDataList() {
                this.loading = false;
                this.$axios.post('sysOperateRecord/operateRecordList' ,{
                    "funcPoint": this.type,
                    "storeId": this.$root.getStorage('storeId')
                }).then(res => {
                    this.dataList = res.data.list;
                }).catch(err => {
                    this.$message.error(err.msg);
                })
            },
            beforeClose() {
                this.loading = false;
                this.$emit('update:visible', false)
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.loading = true;
                this.getDataList();
                console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.loading = true;
                this.getDataList();
                console.log(`当前页: ${val}`);
            }
        }
    }
</script>

<style scoped>

</style>